var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleXFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79688 0.755859C14.6293 0.755859 18.5467 4.67348 18.5469 9.50586C18.5469 14.3384 14.6294 18.2559 9.79688 18.2559C4.96438 18.2559 1.04688 14.3384 1.04688 9.50586C1.04701 4.67348 4.96446 0.755859 9.79688 0.755859ZM13.0303 6.96973C12.7374 6.67683 12.2626 6.67683 11.9697 6.96973L10 8.93945L8.03027 6.96973C7.73738 6.67684 7.26262 6.67684 6.96973 6.96973C6.67684 7.26262 6.67684 7.73738 6.96973 8.03027L8.93945 10L6.96973 11.9697C6.67684 12.2626 6.67684 12.7374 6.96973 13.0303C7.26262 13.3232 7.73738 13.3232 8.03027 13.0303L10 11.0605L11.9697 13.0303C12.2626 13.3232 12.7374 13.3232 13.0303 13.0303C13.3232 12.7374 13.3232 12.2626 13.0303 11.9697L11.0605 10L13.0303 8.03027C13.3232 7.73738 13.3232 7.26262 13.0303 6.96973Z",
    fill: "#6130B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXFilled);
export default __webpack_public_path__ + "static/media/circle-x-filled.ece7634755b68fd44bac8d658ecec8c3.svg";
export { ForwardRef as ReactComponent };